import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Order extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'order',
            data: null,
            loading: true,
            coupon: '',
            affiliateUserCode: ''
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    pay() {
        this.httpPost("api/v1/onlinerecord/paydraft", {
            affiliateUserCode: this.state.affiliateUserCode
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    var form = document.createElement('form');
                    form.setAttribute('method', 'POST');
                    form.setAttribute('action', 'https://bpm.shaparak.ir/pgwchannel/startpay.mellat');
                    var hiddenField = document.createElement('input');
                    hiddenField.setAttribute('name', 'RefId');
                    hiddenField.setAttribute('value', data.refId);
                    form.appendChild(hiddenField);
                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    userCoupon(e) {
        this.httpPost("api/v1/order/usecoupon", {
            coupon: this.state.coupon,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.location.reload();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div>
                    <div className="nk-content-body">
                        <div className="nk-block">
                            <div className="card card-bordered card-stretch">
                                {this.state.data.recordsCount <= 0 ?
                                    <div className="card-inner-group">
                                        <div className="example-alert">
                                            <div className="alert alert-pro alert-warning">
                                                <div className="alert-text">
                                                    <h6>توجه</h6>
                                                    <p>در حال حاضر هیچ آیتم پرداخت نشده ای برای شما وجود ندارد</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <div className="invoice">
                                        <div className="invoice-wrap">
                                            <div className="invoice-bills">
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>شرح کالا/خدمت</th>
                                                                <th className="w-150px">قیمت</th>
                                                                {this.state.data.order.type === 2 && <th className="w-150px">هزینه ارسال</th>}
                                                                <th className="w-150px">مبلغ نهایی</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                    {this.state.data.records.map(record =>
                                                        (this.state.data.order.type == 13 || this.state.data.order.type == 1) ?
                                                                <tr>
                                                                    <td>{record.itemDescription}</td>
                                                                    <td>{this.money(record.total)}</td>
                                                                <td>{this.money(record.total)}</td>
                                                            </tr>
                                                            :
                                                            <tr>
                                                                <td>{record.itemDescription}</td>
                                                                <td>{this.money(record.price)}</td>
                                                                {this.state.data.order.type === 2 && <th className="w-150px">{this.money(record.postPrice)}</th>}
                                                                <td>{this.money((record.price * record.count) - record.discount)}</td>
                                                            </tr>
                                                    )}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                        <td colspan={this.state.data.order.type === 2 ? "3" : "2"}>مجموع</td>
                                                                <td>{this.money(this.state.data.total)} ریال</td>
                                                    </tr>
                                                    {this.isBlank(this.state.data.order.couponId) &&
                                                    <tr>
                                                            <td colspan={this.state.data.order.type === 2 ? "3" : "2"}>کد تخفیف</td>
                                                        <td style={{ "display": "flex", "gap": "3px" }}>
                                                            <input placeholder="کد تخفیف" type="text" onChange={e => this.state.coupon = e.target.value} className="form-control text-center" style={{ "width": "90px" }} />
                                                            <a onClick={e => this.userCoupon(e)} className="btn btn-warning btn-sm">اعمال</a>
                                                                </td>
                                                            </tr>
                                                    }
                                                    <tr>
                                                        <td colspan={this.state.data.order.type === 2 ? "3" : "2"}>کد معرف</td>
                                                        <td style={{ "display": "flex", "gap": "3px" }}>
                                                            <input placeholder="کد معرف" type="text" onChange={e => this.state.affiliateUserCode = e.target.value} className="form-control text-center" style={{ "width": "90px" }} />
                                                        </td>
                                                    </tr>
                                                            <tr>
                                                        <td colspan={this.state.data.order.type === 2 ? "3" : "2"}>تخفیف</td>
                                                                <td>{this.money(this.state.data.totalDiscount)} ریال</td>
                                                            </tr>
                                                            <tr>
                                                        <td colspan={this.state.data.order.type === 2 ? "3" : "2"}>مبلغ نهایی</td>
                                                                <td>{this.money(this.state.data.final)} ریال</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                        <div className="pricing-action">
                                            {this.state.data.final > 0 ?
                                                <button className="btn btn-primary" onClick={e => this.pay()}>تایید و پرداخت</button>
                                                :
                                                <a className="btn btn-primary" href={"/payment/verify/order/" + this.state.data.order.id } >تایید و قطعی شدن سفارش</a>
                                            }
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>


                </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                        this.state.lockScreen === 1 && this.lockScreen(),
                        this.getGlobalContainer(),
                        <Header data={this.state.data} />,
                        <div className="nk-content ">
                            <div className="container-fluid">
                                <div className="nk-content-inner">
                                    {this.renderForm()}
                                </div>
                            </div>
                        </div>,
                        <Footer />
                    ];

        return contents;
    }
}